const DesignBox = () => {
    return (
        <svg width="61" height="56" viewBox="0 0 61 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M59.4883 14.5818L45.8585 22.0673L39.8955 25.3422" stroke="#8984FF" stroke-width="2" stroke-linecap="round"/>
        <path d="M27.8594 1L27.678 9.48788L27.5986 13.2013" stroke="#8984FF" stroke-width="2" stroke-linecap="round"/>
        <path d="M28.6117 32.8872C28.7541 32.6764 28.6076 32.388 28.3534 32.3786C22.5232 32.1639 16.8545 30.3084 12.0362 27.0541C11.8254 26.9118 11.5369 27.0583 11.5276 27.3125C11.3136 33.1229 9.46851 38.795 6.2031 43.6297C6.06073 43.8405 6.20724 44.1289 6.46144 44.1383C12.2917 44.353 17.9603 46.2085 22.7787 49.4628C22.9895 49.6051 23.2779 49.4586 23.2873 49.2044C23.5012 43.394 25.3463 37.7219 28.6117 32.8872Z" fill="#BCB9FF"/>
        </svg>        
        
    );
  };
  
  export default DesignBox;